import { createStyles } from 'antd-style';

export const useStyles = createStyles(({ token, css }) => {
  return {
    container: css`
      height: 100%;
    `,
    prefixWrap: css`
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    `,
    btn: css`
      width: 100%;
      border-radius: 30px;
      height: 50px !important;
    `,
    verifyBox: css`
      width: 60px;
      height: 56px;
      border: 1px solid #f3f2f6;
      border-radius: 4px;
    `,
    footer: css`
      margin-top: 100px;
      padding-bottom: 40px;
    `,
    alert: css`
      margin-bottom: 10px;
    `
  };
});
